import { CommonModule } from '@angular/common';
import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CdkDrag } from '@angular/cdk/drag-drop';

@Component({
    selector: 'add-manage-wrapper',
    template: `
<div class="wrapper">
  <div *ngIf="!!wrapperTitle" class="am-title header" [ngClass]="{withIcon: !!titleIcon}">
    <icon class="titleIcon" *ngIf="titleIcon" [icon]="titleIcon"></icon>
    <h3 *ngIf="titleIcon || useH3ForTitle ">{{ wrapperTitle }}</h3>
    <span *ngIf="!titleIcon && !useH3ForTitle">{{ wrapperTitle }}</span>
    <span *ngIf="!!wrapperSubtitle" class="subtitle">{{ wrapperSubtitle}}</span>
    <!-- <icon *ngIf="hintText" title="{{ hintText }}" icon="INFO12"></icon> ADD BACK INFO ICON LATER? -->
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div *ngIf="!!openLabel && !readOnly" class="label" (click)="open.emit($event)">{{ openLabel }}</div>
  <hr *ngIf="!hideHRule" />
  <div *ngIf="!!secondOpenLabel && !readOnly" class="label second" (click)="secondOpen.emit($event)">{{ secondOpenLabel }}</div>
  <hr *ngIf="!hideHRule" />
</div>
`,
    styleUrls: ['add-manage-wrapper.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent]
})
export class AddManageWrapperComponent {
  @Input() wrapperTitle = ''
  @Input() titleIcon
  @Input() useH3ForTitle
  @Input() openLabel = ''
  @Input() secondOpenLabel = ''
  @Input() hintText
  @Input() wrapperSubtitle
  @Input() readOnly = false
  @Input() hideHRule = false
  @Output() open: EventEmitter<Event> = new EventEmitter()
  @Output() secondOpen: EventEmitter<Event> = new EventEmitter()
}

